// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-wapper {
  background-color: #f5f5f5;
  padding-top: 100px;
  padding-bottom: 80px;
}
.footer-wapper ul {
  padding: 0;
  list-style: none;
}
.footer-wapper ul li {
  margin-bottom: 12px;
  font-size: 14px;
}
.footer-wapper ul li a {
  font-size: 14px;
  color: #000000;
  text-decoration: none;
}
.footer-wapper .footer-one img {
  max-width: 100px;
}
.footer-wapper .footer-five img {
  max-width: 100px;
}

@media (max-width: 1279px) {
  .footer-wapper img {
    max-width: 100px;
  }
}

@media (max-width: 991px) {
  .footer-wapper .footer-one {
    width: 16%;
  }
  .footer-wapper .footer-three {
    width: 23%;
  }
  .footer-wapper .footer-four {
    width: 26%;
  }
}

@media (max-width: 767px) {
  .footer-wapper .footer-one {
    width: 100%;
  }
  .footer-wapper .footer-two {
    width: 50%;
    margin-bottom: 30px;
  }
  .footer-wapper .footer-three {
    width: 50%;
    margin-bottom: 30px;
  }
  .footer-wapper .footer-four {
    width: 50%;
    margin-bottom: 30px;
  }
  .footer-wapper .footer-five {
    width: 50%;
    margin-bottom: 0;
  }
  .footer-wapper .footer-one img {
    display: table;
    margin-bottom: 30px;
  }
  .footer-wapper ul li {
    text-align: left;
    margin-bottom: 4px;
  }
  .footer-wapper {
    padding-top: 30px;
    padding-bottom: 10px;
  }
}

@media (min-width: 1400px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/layout/footer/with-login/with-login.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;EACE;;;;;;IAME,iBAAiB;EACnB;AACF","sourcesContent":[".footer-wapper {\n  background-color: #f5f5f5;\n  padding-top: 100px;\n  padding-bottom: 80px;\n}\n.footer-wapper ul {\n  padding: 0;\n  list-style: none;\n}\n.footer-wapper ul li {\n  margin-bottom: 12px;\n  font-size: 14px;\n}\n.footer-wapper ul li a {\n  font-size: 14px;\n  color: #000000;\n  text-decoration: none;\n}\n.footer-wapper .footer-one img {\n  max-width: 100px;\n}\n.footer-wapper .footer-five img {\n  max-width: 100px;\n}\n\n@media (max-width: 1279px) {\n  .footer-wapper img {\n    max-width: 100px;\n  }\n}\n\n@media (max-width: 991px) {\n  .footer-wapper .footer-one {\n    width: 16%;\n  }\n  .footer-wapper .footer-three {\n    width: 23%;\n  }\n  .footer-wapper .footer-four {\n    width: 26%;\n  }\n}\n\n@media (max-width: 767px) {\n  .footer-wapper .footer-one {\n    width: 100%;\n  }\n  .footer-wapper .footer-two {\n    width: 50%;\n    margin-bottom: 30px;\n  }\n  .footer-wapper .footer-three {\n    width: 50%;\n    margin-bottom: 30px;\n  }\n  .footer-wapper .footer-four {\n    width: 50%;\n    margin-bottom: 30px;\n  }\n  .footer-wapper .footer-five {\n    width: 50%;\n    margin-bottom: 0;\n  }\n  .footer-wapper .footer-one img {\n    display: table;\n    margin-bottom: 30px;\n  }\n  .footer-wapper ul li {\n    text-align: left;\n    margin-bottom: 4px;\n  }\n  .footer-wapper {\n    padding-top: 30px;\n    padding-bottom: 10px;\n  }\n}\n\n@media (min-width: 1400px) {\n  .container,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container-xl,\n  .container-xxl {\n    max-width: 1200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
